// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-sign-incorrect-invoice .table thead th{vertical-align:middle}.modal-sign-incorrect-invoice .table.b-table>tbody .b-table-row-selected.table-active td{background-color:#fff;color:#000}", ""]);
// Exports
module.exports = exports;
